import React from "react";
import { Box, Button, Checkbox, Select, SelectOption, Text } from "@showitinc/showit-wc";

import AppConstants from "../../constants/AppConstants";
import LayoutChooserActions from "../../actions/LayoutChooserActions";
import PreviewArea from "../designchooser/PreviewArea";
import ButtonBar from "../base/ButtonBar";
import { recursivelyCopySyncedPropsToMobile } from "../../utils/SyncUtils";
import uiPrefix from "../../utils/UiPrefixUtils";

const LayoutChooser = ({ settings, preview }) => {
  const _onLayoutChange = (propInfo) => {
    LayoutChooserActions.updateSetting(propInfo.name, propInfo.value);
  };

  const { layout, copyBlockProps, copyElementProps } = settings;

  const viewAreaStyle = {
    display: "flex",
    minHeight: 0,
    justifyContent: "flex-start",
    alignItems: "stretch",
    alignContent: "stretch",
    flex: "1 1 auto",
    position: "relative",
    height: "100%",
  };

  const [theme] = recursivelyCopySyncedPropsToMobile(preview.theme);

  return (
    <div style={{ position: "relative", height: "100%", display: "flex", flexDirection: "column" }}>
      <div style={viewAreaStyle}>
        <div style={{ paddingLeft: 8, paddingRight: 8, width: 350 }}>
          <Box pt="3" pl="2" pr="2">
            <Text>
              If you&apos;ve only built out the desktop version of this canvas, these imperfect
              auto-generated layouts should save you significant time as you create the perfect
              mobile experience.
            </Text>
          </Box>

          <Text className="panel-subheading">Layout</Text>
          <Select
            label="Method"
            value={layout}
            onSISelect={(e) => _onLayoutChange({ name: "layout", value: e.target.value })}
          >
            <SelectOption value="auto">Auto</SelectOption>
            <SelectOption value="scale">Scaled</SelectOption>
            <SelectOption value="stack">Stacked</SelectOption>
            <SelectOption value="none">Do Not Layout</SelectOption>
          </Select>

          <Text className="panel-subheading">Style & Settings</Text>

          <Checkbox
            label="Copy canvas styles"
            checked={copyBlockProps}
            onSIChange={(e) => _onLayoutChange({ name: "copyBlockProps", value: e.target.checked })}
          />

          <Checkbox
            label="Copy element styles"
            checked={copyElementProps}
            onSIChange={(e) =>
              _onLayoutChange({ name: "copyElementProps", value: e.target.checked })
            }
          />
        </div>

        <PreviewArea theme={theme} preview={preview} layout={AppConstants.LAYOUT_MOBILE} />
      </div>
      <ButtonBar style={{ padding: 8 }}>
        <Box mr="3">
          <Button
            variant="minimal"
            data-e2e={uiPrefix("modal-cancel-btn")}
            className={uiPrefix("modal-cancel-btn")}
            onClick={LayoutChooserActions.closeDialog}
          >
            Cancel
          </Button>
        </Box>
        <Button
          variant="feature"
          data-e2e={uiPrefix("modal-update-btn")}
          className={uiPrefix("modal-update-btn")}
          onClick={LayoutChooserActions.updateBlock}
        >
          OK
        </Button>
      </ButtonBar>
    </div>
  );
};

export default LayoutChooser;
